import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../../config';

const baseUrl = config.baseUrl;
const orgEndpointInsert = '/api/visita';


const api = axios.create({
    baseURL: config.baseUrl,
});

api.interceptors.request.use(
    (config) => {
        const token = Cookies.get('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const getVisitaPorTipoAndCodigo = async (id_participante, id_tipo_visita) => {
    try {
      const response = await axios.get(`${baseUrl}${orgEndpointInsert}?id_participante=${id_participante}&id_tipo_visita=${id_tipo_visita}`, {
        headers: {
            'Content-Type': 'application/json',  // Encabezado JSON para enviar datos correctamente
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error al crear la encuesta:', error);
      throw error;
    }
  };
  export default getVisitaPorTipoAndCodigo;